import {getWebsiteId} from "./getWebsiteId";
import {isDevEnvironment} from "./isDevEnvironment";

export const checkIsWhiteLabelApp = () => {
  const hasCustomTheme = localStorage.getItem("theme")?.split("-")[0] === "custom";
  const startWithApp = window.location.hostname.startsWith("app.");
  const startWithBuild = window.location.hostname.startsWith("build.");
  const isAnyHumanKindHostname = ["forthwithlife.co.uk", "sportsbloodtests.co.uk", "biomarkertracking.com"].some(
    domain => window.location.hostname.includes(domain),
  );

  return (
    getWebsiteId() === 3 &&
    (!isDevEnvironment || (isDevEnvironment && hasCustomTheme)) &&
    (!isAnyHumanKindHostname ||
      (isAnyHumanKindHostname && window.location.hostname.startsWith("whitelabel.")) ||
      (isAnyHumanKindHostname && !startWithApp && !startWithBuild))
  );
};
